<template>
  <ul class="radio-box" :class="{ disabled: disabled }">
    <li
      v-for="opt in options"
      :key="opt.value"
      v-tooltip="opt.tooltip"
      :style="opt.style"
      :tabindex="disabled ? -1 : 0"
      :class="{
        'radio-cell': true,
        active: opt.value === value,
        disabled: disabled
      }"
      @click="select(opt.value)"
    >
      {{ opt.label }}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'RadioBox',
  model: {
    prop: 'value',
    event: 'select'
  },
  props: {
    value: String | Number,
    options: Array,
    disabled: Boolean
  },
  methods: {
    select(value) {
      if (this.disabled) return
      this.$emit('select', value)
    }
  }
}
</script>

<style lang="less" scoped>
.radio-box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
}
.radio-cell {
  flex: 1;
  height: 30px;
  margin-right: 10px;
  line-height: 28px;
  color: #838d9e;
  text-align: center;
  border: solid 1px var(--light-grey);
  border-radius: 2px;
  cursor: pointer;
  outline: none;
  &:last-child {
    margin-right: 0;
  }
  &.active {
    color: var(--active-color);
    border-color: var(--active-color);
  }
  &:not(.disabled):focus {
    border-color: var(--active-color);
  }
  &.disabled {
    opacity: 0.8;
    cursor: default;
  }
}
</style>
